exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".von-scalable-wrapper{position:relative}.von-scalable-wrapper .von-scalable{position:absolute}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js!./~/sass-loader!./~/vue-loader/lib/selector.js?type=style&index=0!./src/components/scalable/index.vue
// module id = 172
// module chunks = 0